<template>
  <div class="Statistical full-height">
    <!-- 顶部 bg-main-->
    <div class="top-div">
      <div class="top-year">
        日期选择：<div class="date-line" @click="selYear">
          {{ `${countStartDate} 至 ${countEndDate}` }}
        </div>
      </div>
      <div class="top-middle-zhichu">
        <div class="title-color">
          共计支出（元）
        </div>
        <div class="zhichu-money">
          {{ total | currency }}
        </div>
      </div>
      <div class="top-middle">
        <div class="top-item">
          <span class="title-color">节省金额</span>
          <span class="pdtop5 font-bold font16">{{ saveMoney | currency }}</span>
        </div>
        <div class="shuxian">
          <div class="shuxian-div"/>
        </div>
        <div class="top-item">
          <span class="title-color">节省百分比</span>
          <span class="pdtop5 font-bold font16">{{ savePercent }}%</span>
        </div>
      </div>
      <!--      <div class="top-bottom">
      </div>-->
    </div>
    <!-- 中间白色 -->
    <div class="middle-div-bgwhite"/>
    <!-- 底部列表 -->
    <div class="bottom-div">
      <mescroll-vue
        ref="mescroll"
        :down="down"
        @init="mescrollInit"
      >
        <van-pull-refresh
          v-model="isLoading"
          @refresh="onRefresh"
        >
          <van-list
            v-model="countPage.loading"
            :finished="countPage.finished"
            :error.sync="countPage.error"
            :error-text="countPage.errorText"
            :finished-text="countPage.finishedText"
            @load="countTkList(countPage.pageNum++)"
          >
            <van-cell title-class="full-width">
              <template
                slot="title"
                class="full-width"
              >
                <div
                  v-for="item in countPage.list"
                  :key="item.id"
                  class="m-b-5"
                >
                  <van-row
                    type="flex"
                    align="center"
                    justify="space-between"
                  >
                    <van-col span="17">
                      <div class="-inline-wrap">
                        <div class="-block-wrap">
                          <div class="-block">
                            <ld-icon
                              class="block-order-icon main-color"
                              type="iconweibiaoti-1"
                            />
                            <span class="font16 font-bold">
                              <span> {{ item.voyageZh }}</span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </van-col>
                    <van-col
                      span="7"
                      class="red text-right"
                    >
                      <span class="font12">&yen; </span>
                      {{
                        item.payTotal|fixed(2)
                      }}
                    </van-col>
                  </van-row>
                  <van-row>
                    <van-col
                      span="17"
                      class="van-ellipsis"
                    >
                      {{ item.createdate.substring(5,10) }} | {{ item.airlineName }} | {{ item.flightNo }}
                      <!--              {{ item.departTime }} | {{ item.flightNo }} | {{ item.cabinName }}-->
                    </van-col>
                    <van-col
                      span="7"
                      class="text-right"
                    >
                      <van-tag color="#3465ea">
                        <span class="font12">节省&yen; </span>
                        {{
                          item.saveMoney|fixed(2)
                        }}
                      </van-tag>
                    </van-col>
                  </van-row>
                  <div>
                    <span class="line-clamp">
                      {{ item.psg }}
                    </span>
                  </div>
                </div>
              </template>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </mescroll-vue>
    </div>

    <!-- 组件 -->
    <statistical-calendar
      ref="date"
      type="range"
      @selected="getDate"
      allow-same-day
      start-text="开始"
      end-text="结束"
      :min-date="minDate"
      :max-date="maxDate"
    />
  </div>
</template>

<script>
import { Calendar,List, Cell, Tag, PullRefresh } from 'vant'
import {formatDate} from "Utils/dateUtil";
import statisticalCalendar from "./components/statisticalCalendar";
import MescrollVue from "mescroll.js/mescroll";
export default {
  name: 'Statistical',
  components: {
    [Calendar.name]:Calendar,
    [List.name]: List,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [PullRefresh.name]: PullRefresh,
    statisticalCalendar,
    MescrollVue
  },
  data () {
    return {
      minDate: formatDate(new Date('2022/01/01')).datetime,
      maxDate: formatDate(new Date()).datetime,
      total: '',
      saveMoney: '',
      savePercent: '',
      countStartDate : '',
      countEndDate : '',
      countPage: {
        pageNum: 1,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        pullRefreshLoading: false,
        list: []
      },
      down: { use: false },
      isLoading: false,
      mescroll: ''
    }
  },
  created () {
    var format = formatDate(new Date())
    this.countStartDate = format.date
    this.countEndDate = format.date
    
    this.countTkInfo();
    this.countTkList();
  },
  methods: {
    selYear(){
      this.$refs.date.toggle({
        defaultDate: [this.countStartDate,this.countEndDate],
        minDate: this.minDate,
        maxDate: this.maxDate
      })
    },
    //获取日期回调
    getDate(date) {
      var start = formatDate(date[0])
      var end = formatDate(date[1])
      this.countStartDate = start.date
      this.countEndDate = end.date
      this.countTkInfo()
      this.countTkList()
    },
    async countTkInfo(){
      let params = {
        startDate: this.countStartDate,
        endDate: this.countEndDate
      }
      await this.$api['statistical/countTkInfo'](params).then(res => {
        this.total = res.data.total
        this.saveMoney = res.data.saveMoney
        this.savePercent = res.data.savePercent
      }).catch(err => {
        throw err
      })
    },
    async countTkList(){
      this.countPage.loading = true
      let params = {
        pageNum: this.countPage.pageNum,
        count: this.countPage.count,
        startDate: this.countStartDate,
        endDate: this.countEndDate
      }
      await this.$api['statistical/countTkList'](params).then(res => {
        this.countPage.loading = false
        let dataList = res.data.list
        if (dataList.length < this.countPage.count){
          this.countPage.finished = true
        }
        if (params.pageNum > 1) {
          this.countPage.list.push(...dataList)
        } else {
          this.countPage.list = dataList
        }
      }).catch(err => {
        this.countPage.loading = false
        this.countPage.finished = true
        throw err
      })
    },
    onRefresh() {
      this.countPage.pageNum = 1
      this.countPage.finished = false
      this.countTkList()
      this.isLoading = false
    },
    mescrollInit (mescroll) {
      this.mescroll=mescroll
    }
  },
  filters: {
    currency(amount) {
      if(!amount) {
        return "0.00"
      }
      //强制保留两位小数
      let f = parseFloat(amount);
      if (isNaN(f)) return false;
      f = Math.round(amount * 100) / 100;
      let s = f.toString();
      let rs = s.indexOf('.');
      if (rs < 0) {
        rs = s.length;
        s += '.';
      }
      while (s.length < (rs + 1) + 2) {
        s += '0';
      }
      //每三位用一个逗号隔开
      let leftNum=s.split(".")[0];
      let rightNum="."+s.split(".")[1];
      let result;
      //定义数组记录截取后的价格
      let resultArray=new Array();
      if(leftNum.length>3){
        let i=true;
        while (i){
          resultArray.push(leftNum.slice(-3));
          leftNum=leftNum.slice(0,leftNum.length-3);
          if(leftNum.length<4){
            i=false;
          }
        }
        //由于从后向前截取，所以从最后一个开始遍历并存到一个新的数组，顺序调换
        let sortArray=new Array();
        for(let i=resultArray.length-1;i>=0;i--){
          sortArray.push(resultArray[i]);
        }
        result=leftNum+","+sortArray.join(",")+rightNum;
      }else {
        result=s;
      }
      return result;
    }
  }
}
</script>

<style lang="less" scoped>
.Statistical {
  background: #ffffff;
  .pdtop5{
    padding-top: 5px;
  }
  .top-div{
    background-color: #3465ea;
    display: flex;
    flex-direction: column;
    color: #fff;
  }
  .top-year{
    display: flex;
    font-weight: bold;
    padding: 20px 20px 10px 20px;
    font-size: 16px;
  }
  .top-middle-zhichu{
    padding-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .title-color{
    color: #a8adea;
  }
  .zhichu-money{
    font-size: 30px;
    font-weight: bold;
    padding-top: 5px;
  }
  .top-middle{
    display:flex;
    align-content: center;
    padding-bottom: 10px;
  }
  .top-item{
    display:flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 80px;
    font-size: 14px;
  }
  .shuxian{
    display: flex;
    align-items: center;
    width: 1px;
  }
  .shuxian-div{
    width: 1px;
    height: 20px;
    background: #fff;
    opacity: 0.3;
  }
  .top-bottom{
    display:flex;
    align-content: center;
    font-weight: bold;
    padding-bottom: 20px;
  }
  .bottom-item{
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
  }
  .middle-div-bgwhite{
    background: #ffffff;
    height: 20px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    margin-top: -10px;
  }
  .bottom-div{
    padding-bottom: 50px;
    height: calc(100vh - 230px);
    overflow: hidden;
  }
  /deep/ .van-picker__confirm{
    color: #3465ea;
  }
  /deep/ .van-list__finished-text{
    line-height: normal !important;
  }
  /deep/ .van-cell::after{
    border-bottom: none !important;
  }
  .date-line{
    border-bottom: 1px solid #a8adea;
  }
  .m-b-5 {
    margin-bottom: 8px;
    border-bottom: 5px solid #f6f6f5;
  }
  .line-clamp {
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    word-break: break-all;
  }
}
</style>
